import React from "react";
import { Box, Stepper, Step, StepLabel, StepConnector, StepButton } from "@mui/material";
import { styled } from "@mui/material/styles";
import DoneIcon from "@mui/icons-material/Done";
import EditIcon from "@mui/icons-material/Edit";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { translate } from "../../../../translate/translate";

const steps = ["customer", "forecast", "period", "priority"];

export enum Steps {
    Customer = 0,
    Forecast = 1,
    Period = 2,
    Priority = 3,
}

const colors = {
    primary: "#303F9F",
    primary_light: "#303F9F66",
    secondary: "#90A4AE",
    secondary_light: "#90A4AE66",
    success: "#43BA75",
    success_light: "#43BA7566",
    dark: "#45485F",
};

const CustomStepConnector = styled(StepConnector)(() => ({
    "& .MuiStepConnector-line": {
        borderColor: colors.secondary,
        borderWidth: 2,
        transition: "border-color 0.3s ease-in-out",
    },
    "&.Mui-active .MuiStepConnector-line, &.Mui-completed .MuiStepConnector-line": {
        borderColor: colors.success,
    },
}));

const StepIconRoot = styled("div")<{ ownerState: { completed?: boolean; active?: boolean } }>(
    ({ ownerState }) => ({
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: 25,
        height: 25,
        borderRadius: "50%",
        backgroundColor: ownerState.completed ? colors.success : ownerState.active ? colors.primary :  colors.secondary,
        color: "white",
        border: `3px solid ${ownerState.completed ? colors.success_light : ownerState.active ? colors.primary : colors.secondary_light}`,
        outline: `3px solid ${ownerState.completed ? colors.success_light : ownerState.active ? colors.primary_light : colors.secondary_light}`,
        transition: "all 0.3s ease-in-out",
    })
);


function CustomStepIcon({ active, completed }: { active: boolean; completed: boolean }) {
    return (
        <StepIconRoot ownerState={{ active, completed }}>
            {completed ? <DoneIcon fontSize="small" /> : active ? <EditIcon fontSize="small" /> : <MoreHorizIcon fontSize="small" />}
        </StepIconRoot>
    );
}

const StepperComponent: React.FC<{ activeStep: number; setActiveStep: (step: number) => void }> = ({ activeStep, setActiveStep }) => {
    return (
        <Box sx={{ width: "100%", mt: 3 }}>
            <Stepper activeStep={activeStep} alternativeLabel connector={<CustomStepConnector />}>
                {steps.map((label, index) => (
                    <Step key={label}>
                        <StepButton disabled color="inherit" onClick={() => setActiveStep(index)}>
                            <StepLabel StepIconComponent={() => <CustomStepIcon active={index === activeStep} completed={index < activeStep} />}>
                                <div style={{color: colors.dark, fontSize: "14px", fontWeight:400}}>{translate.t(label)}</div>
                            </StepLabel>
                        </StepButton>
                    </Step>
                ))}
            </Stepper>
        </Box>
    );
};

export default StepperComponent;
